import Header from './Header'
import Footer from './Footer'

const Layout = ({children, alone}) => {
    return (
        <>
            {alone ? (
                <main>{children}</main>
            ):(
                <>
                <Header />
                <div className='spacer-50' />
                <main>{children}</main>
                <Footer />
                </>
            )}
        </>
    )
}
export default Layout